import {gnv, snv} from "@Common/utils/arr-path";

export const getAssetSources = (ccConfig, userData) => {
    let ret = ccConfig['editorConfigurations']['assetSources'];
    const galleriesObject = ccConfig['galleries'];
    // console.log("galleriesObject", galleriesObject);

    for (const galleryName in galleriesObject) {
        try {

            const galleryPath = galleriesObject[galleryName].binding;
            const galleryTitle = galleriesObject[galleryName].title;
            const galleryPreview = galleriesObject[galleryName].preview;
            const gallerySource = galleriesObject[galleryName].source;

            const userFields = gnv(
                userData['sourceData'] || userData,
                galleryPath.split('.')
            );

            if (userFields) {
                //apply user data to config data
                ret = snv(ret, [galleryName, "rootCategory", "assets",], userFields.map((userField) => ({
                    'title': userField[galleryTitle],
                    'preview': userField[galleryPreview],
                    'source': userField[gallerySource],
                })))
            }
        } catch (e) {
            console.log("Error binding the gallery", e);
        }
    }

    return ret;

};
